import { IMenuItem } from '../../models/menu.model';

export const listsDeskMenu: IMenuItem = {
  label: 'Lists Desk',
  path: 'lists-desk',
  id: 'MID_LISTS_DESK_ROOT',
  icon: 'fa fa-list',
  children: [
    { path: 'parameters', label: 'List Values', id: 'MID_LISTS_DESK_PARAMETERS' },
    { path: 'currency', label: 'Currency', id: 'MID_LISTS_DESK_CURRENCY' },
    { path: 'country', label: 'Countries', id: 'MID_LISTS_DESK_COUNTRY' },
    { path: 'state', label: 'States', id: 'MID_LISTS_DESK_STATE' },
    { path: 'town', label: 'Towns', id: 'MID_LISTS_DESK_TOWN' },
    {
      label: 'Vehicle',
      id: 'MID_LISTS_DESK_VEHICLE',
      children: [
        { path: 'vehicle/brands', label: 'Brands', id: 'MID_LISTS_DESK_VEHICLE_BRANDS' },
        { path: 'vehicle/make', label: 'Make', id: 'MID_LISTS_DESK_VEHICLE_MAKE' },
        { path: 'vehicle/model', label: 'Model', id: 'MID_LISTS_DESK_VEHICLE_MODEL' },
      ],
    },
    {
      path: 'shipping-vessels',
      label: 'Shipping Vessels',
      id: 'MID_LISTS_DESK_SHIPPING_VESSELS',
      children: [
        { path: 'brand', label: 'Brand', id: 'MID_LISTS_DESK_SHIPPING_VESSELS_BRANDS' },
        { path: 'make', label: 'Make', id: 'MID_LISTS_DESK_SHIPPING_VESSELS_MAKE' },
        { path: 'model', label: 'Model', id: 'MID_LISTS_DESK_SHIPPING_VESSELS_MODEL' },
      ],
    },
    { path: 'shipping-ports', label: 'Shipping Ports', id: 'MID_LISTS_DESK_SHIPPING_PORTS' },
    { path: 'companies', label: 'Companies', id: 'MID_LISTS_DESK_COMPANIES' },
    { path: 'brokers', label: 'Brokers', id: 'MID_LISTS_DESK_BROKERS' },
    { path: 'loss-adjusters', label: 'Loss Adjusters', id: 'MID_LISTS_DESK_LOSS_ADJUSTERS' },
  ],
};
